import { useEffect, useRef, useState } from 'react';
import { Link } from '../../../../../../../../../../Resource/Types';
import { setFilteringState, setOptionSelectedState } from './Actions';
import { handleInputChange, handleSelectionChange } from './Handlers';
import { FilterOption, ready, State } from './Types';
import { fetchOptionsReaction } from './Reactions';
import { assertNever } from '@kofno/piper';

export const useGroupDynamicTypeaheadSelect = (
  endpoint: Link,
  onChange: (value: FilterOption) => void,
) => {
  const [state, setState] = useState<State>(ready);

  const debouncer = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    switch (state.kind) {
      case 'filtering':
        fetchOptionsReaction(endpoint, state, setState);
        break;
      case 'error':
      case 'filtered':
      case 'option-selected':
      case 'ready':
        break;
      default:
        assertNever(state);
    }
  }, [state, endpoint]);

  return {
    state,
    handleInputChange: handleInputChange(debouncer, setFilteringState(state, setState)),
    handleSelectionChange: handleSelectionChange(onChange, setOptionSelectedState(state, setState)),
  };
};
